module.exports = __webpack_public_path__ + "img/cassette-tape.12e55934.svg";